import {
  StaticSegmentFormStateType,
  SourceTypeDropdownOptionsType,
  DynamicSegmentFormStateType,
  DynamicSegmentRelationDataType,
  DynamicSegmentSchemaDataType,
  CategoryTabConfigType,
  DynamicSegmentFormErrorStateType,
  DynamicSegmentDimensionType,
  SegmentSortOrderType
} from 'src/lib/types/segment'

export const defaultStaticSegmentFormState: StaticSegmentFormStateType = {
  name: '',
  description: '',
  segmentType: 'PHONE_NUMBER',
  sourceType: 'CSV',
  sourceFile: null,
  inclusionList: [],
  manualInput: ''
}

export const sourceTypeDropdownOptions: SourceTypeDropdownOptionsType[] = [
  {
    value: 'CSV',
    label: 'Upload a CSV'
  },
  {
    value: 'SORTMENT',
    label: 'Sortment import',
    disabled: true
  }
]

export const defaultPreviewFilters: DynamicSegmentDimensionType[] = [
  {
    id: 'FCT__CUSTOMER_PROFILE_PHONE',
    name: 'Phone',
    tableName: 'FCT__CUSTOMER_PROFILE',
    tableType: 'RELATED'
  }
]
export const defaultDynamicSegmentFormState: DynamicSegmentFormStateType = {
  isActive: true,
  name: '',
  description: '',
  tags: [],
  filters: [],
  previewFilters: defaultPreviewFilters
}

export const defaultDynamicSegmentFormErrorState: DynamicSegmentFormErrorStateType = {
  name: {
    status: false,
    message: ''
  },
  filters: []
}

export const defaultRelationData: DynamicSegmentRelationDataType = {
  relationId: '',
  dimensions: []
}

export const defaultSchemaData: DynamicSegmentSchemaDataType = {
  fields: [],
  dataTypes: []
}

export const DynamicSegmentColumnCategoryTabs: CategoryTabConfigType[] = [
  {
    key: 'USER_ATTRIBUTES',
    label: 'User Attributes'
  },
  {
    key: 'EVENT_ATTRIBUTES',
    label: 'Event Attributes'
  },
  {
    key: 'NETWORK_ATTRIBUTES',
    label: 'Network Attributes'
  },
  {
    key: 'OTHERS',
    label: 'Others'
  }
]

export const SegmentListSortOptions: { key: SegmentSortOrderType; value: string }[] = [
  { key: 'NEWEST', value: 'Newest First' },
  { key: 'OLDEST', value: 'Oldest First' },
  { key: 'NAME_ASC', value: 'Name Ascending' },
  { key: 'NAME_DESC', value: 'Name Descending' }
]
